module.exports = __webpack_public_path__ + "15e5e52adf9ac659fd8c5ec141e98c5d.svg";